import type { CrudConfig } from '@startupquickstart/frontend';

export interface ThemeType {
  id: string;
  name: string;
  slug: string;
  description?: string | null;
  tone?: string | null;
  createdAt: string;
  updatedAt: string;
}

export const themeTypeCrudConfig: CrudConfig<ThemeType> = {
  entityName: 'Theme Type',
  entityNamePlural: 'Theme Types',

  endpoints: {
    list: '/theme-types',
    single: (id) => `/theme-types/${id}`,
    create: '/theme-types',
    update: (id) => `/theme-types/${id}`,
    delete: (id) => `/theme-types/${id}`,
  },

  fields: [
    {
      key: 'name',
      label: 'Name',
      type: 'text',
      required: true,
      validation: { min: 2, max: 200 },
      helpText: 'Display name for the theme type (e.g., "Ghostly", "Historical")',
    },
    {
      key: 'slug',
      label: 'Slug',
      type: 'text',
      required: true,
      validation: {
        pattern: /^[a-z0-9-]+$/,
        custom: (value: string) => {
          if (!/^[a-z0-9-]+$/.test(value)) {
            return 'Slug must be lowercase with hyphens only';
          }
          return null;
        },
      },
      helpText: 'URL-friendly identifier (e.g., "ghostly", "historical")',
    },
    {
      key: 'description',
      label: 'Description',
      type: 'textarea',
      required: false,
      helpText: 'Brief description of what this theme represents',
    },
    {
      key: 'tone',
      label: 'Tone',
      type: 'textarea',
      required: false,
      helpText:
        'Tone/style description for AI generation (e.g., "Mysterious, spooky, and atmospheric")',
    },
  ],

  listView: {
    fields: ['name', 'slug', 'tone', 'createdAt'],
    searchableFields: ['name', 'slug'],
    sortableFields: ['name', 'slug', 'createdAt'],
    itemsPerPage: 10,
    actions: {
      create: { enabled: true },
      view: { enabled: true },
      edit: { enabled: true },
      delete: { enabled: true },
    },
  },

  detailView: {
    sections: [
      {
        title: 'Basic Information',
        fields: ['name', 'slug', 'description', 'tone', 'createdAt', 'updatedAt'],
        defaultExpanded: true,
      },
    ],
  },

  form: {
    sections: [
      {
        title: 'General',
        fields: ['name', 'slug', 'description', 'tone'],
        columns: 1,
      },
    ],
  },
};
